import { strings as stringManager } from '../../Strings';
export const moduleName = 'marketSnapshotCard';
stringManager.load(moduleName, {
    basePayHeader: 'Annual Base Pay',
    cardTitle: 'Market Snapshot',
    description: '* Base salary, bonus, and other factors are all collected separately and may not add up to TCC',
    percentile25th: '25th',
    percentile50th: '50th',
    percentile75th: '75th',
    tccHeader: 'TCC*'
});
const moduleStrings = stringManager[moduleName];
export { moduleStrings as strings };
export default moduleStrings;
